class Controller {
  constructor($mdDialog, $injector, shift) {
    "ngInject";

    this.$injector = $injector;
    this.$mdDialog = $mdDialog;
    this.shift = shift;
  }

  close() {
    this.$mdDialog.cancel();
  }

  confirm() {
    this.$mdDialog.hide();
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/corporate/removeShiftDialog/removeShiftDialog.controller.js